/**
 * Selection color palette for transcript elements
 * Nine distinct colors for highlighting text selections
 */
export const SELECTION_COLORS = [
  { name: 'Red', value: '#FF6B6B' },
  { name: 'Orange', value: '#FFA726' },
  { name: 'Yellow', value: '#FFD93D' },
  { name: 'Green', value: '#6BCF7F' },
  { name: 'Blue', value: '#4DABF7' },
  { name: 'Purple', value: '#9775FA' },
  { name: 'Pink', value: '#FF8CC2' },
  { name: 'Brown', value: '#A68A64' },
  { name: 'Gray', value: '#868E96' },
] as const;

export type SelectionColor = typeof SELECTION_COLORS[number];
export type SelectionColorValue = SelectionColor['value'];